import { createAction, props } from '@ngrx/store';
import { SidebarSection } from '../models/sidebar-section.model';

export const toggleSidebar = createAction('[UI] Toggle Sidebar');

export const setSidebarItems = createAction(
  '[UI] Set Sidebar Items',
  props<{ items: SidebarSection[] }>()
);
